export default __webpack_public_path__ + "static/media/h2.0c7c1dfd.jpg";